import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import Asset from '@/model/dataLayer/api/MembershipSystem/Asset'
import UserMembership from '@/model/dataLayer/api/MembershipSystem/UserMembership'
import dayjs from 'dayjs'
import { groupBy } from 'lodash'

const path = 'api/asset-records/'
export const AssetStatus = [{ value: 'DISTRIBUTED', name: 'DISTRIBUTED' }, { value: 'USED', name: 'USED' }, { value: 'EXPIRED', name: 'EXPIRED' }, { value: 'REVOKED', name: 'REVOKED' }]

const entity = {
  operation: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  assetId: {
    displayName: '资产',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => { return await Asset.getList(true) },
        itemText: 'name',
        itemValue: 'id'
      }
    }
  },
  distributedBy: {
    displayName: '分发人'
  },
  distributedAtDisplay: {
    form: false
  },
  usedAtDisplay: {
    form: false
  },
  status: {
    displayName: 'Status',
    type: IKDataEntity.Types.Option,
    header: false,
    formConfig: {
      type: {
        selectItems: async () => { return AssetStatus },
        itemText: 'name',
        itemValue: 'value'
      }
    }
  },
  statusDisplay: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  userId: {
    displayName: '用户',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => { return await UserMembership.getList(true) },
        itemText: 'username',
        itemValue: 'userId'
      }
    }
  }
}

const config = {
  load: async function (filter) {
    const res = (await hillo.get(cloudV2Url + path + 'business-layer/' + GlobalConfig.blId)).map(it => {
      it.distributedAtDisplay = it.distributedAt ? dayjs(it.distributedAt).format('YYYY-MM-DD') : '-'
      it.usedAtDisplay = it.usedAt ? dayjs(it.usedAt).format('YYYY-MM-DD') : '-'
      return it
    })
    const result = groupBy(res, 'assetId')
    const realResult = Object.entries(result).map(it => {
      return { assetId: it[0], detailInfo: it[1] }
    })
    console.log(realResult, 'real')
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function cancelRecord (id, item) {
  return (await hillo.jsonPost(cloudV2Url + path + id + '/revoke', {
    ...item
  }))
}

export async function getAllRecordList () {
  const res = (await hillo.get(cloudV2Url + path + 'business-layer/' + GlobalConfig.blId)).map(it => {
    it.distributedAtDisplay = it.distributedAt ? dayjs(it.distributedAt).format('YYYY-MM-DD') : '-'
    it.usedAtDisplay = it.usedAt ? dayjs(it.usedAt).format('YYYY-MM-DD') : '-'
    return it
  })
  const result = groupBy(res, 'assetId')
  return Object.entries(result).map(it => {
    return {
      assetId: it[0],
      detailInfo: it[1],
      assetInfo: it[1][0].assetInfo,
      statusInfo: Object.entries(groupBy(it[1], 'status')).map(x => {
        return { status: x[0], length: x[1].length }
      })
    }
  })
}
